import { render, staticRenderFns } from "./MailHistoryList.vue?vue&type=template&id=0971e67d&"
import script from "./MailHistoryList.vue?vue&type=script&lang=js&"
export * from "./MailHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./MailHistoryList.vue?vue&type=style&index=0&id=0971e67d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports